import React from "react";

import "./CeoMessage.scss";

const CeoMessage = () => {
  return (
    <div className="ceoMessage">
      <div>
        <h2>Ceo Message</h2>
        <p>
          Petroen Engineering DMCC with its presence in the market along with its subsidiaries has
          positioned itself as uniquely as a progressive, Dynamic and forward-looking organization. We
          successfully introduced a unique portfolio of products and services that cater its distinguished
          clients with full customer satisfaction. I am full of optimism and confidence leading the
          organization which appreciates its customer needs and requirements to create a fulfilling
          experience for them, I am sure that you will find this rapidly growing organization the ideal
          consultants and partners to manage your needs effectively and together we shall build a
          concrete business relationship. Our vision is very clear and the team is focused and is
          experienced. The team has sizable hands-on experience of designing and delivering the
          projects within the prescribed time limit. We have our own well developed and monitored
          quality and safety policy which we adhere at all stages of execution, this is the reason we are
          able to deliver quality services and backup support to our valued customers.
          <br />
          Khurram Bin Latif.
          <br />
          Chief Executive Officer,
          <br />
          Petroen Engineering DMCC
        </p>
      </div>
    </div>
  );
};
export default CeoMessage;
